"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.ButtonContainer = exports.GradientOverlay = exports.SearchIconContainer = exports.Button = exports.ImageContainer = exports.Description = exports.ListItem = exports.List = exports.ListContainer = exports.InfoContainer = exports.ArrowIcon = exports.Title = exports.TitleContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../../UI/Typography"));
const svg_components_1 = require("../../../../assets/svg-components");
const Button_1 = __importDefault(require("../../../../Components/Button"));
const Container_1 = __importDefault(require("../../../../Components/UI/Container"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
exports.Container = styled_components_1.default.div `
  width: 100%;
  margin-top: ${props => props.theme.spacing.m5}px;
  margin-bottom: ${props => props.theme.spacing.s4}px;


  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-bottom: ${props => props.theme.spacing.s5}px;
  }
`;
exports.TitleContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.m1}px;
`;
exports.Title = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.s5}px;

  > h1 {
    color: ${props => props.theme.palette.LIGHT_BLACK};
    margin: 0;
  }
`;
exports.ArrowIcon = (0, styled_components_1.default)(svg_components_1.ArrowLeftBigIcon) `
  cursor: pointer;
  flex-shrink: 0;
  padding-bottom: ${props => props.theme.spacing.s1}px;
  box-sizing: content-box;
  width: ${props => props.theme.constants.blockHeight.s14}px;
  height: ${props => props.theme.constants.blockHeight.s14}px;
  margin-top: ${props => props.theme.spacing.s1}px;
`;
exports.InfoContainer = (0, styled_components_1.default)(Container_1.default) `
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0;
`;
exports.ListContainer = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: 0;
  margin-right: ${props => props.theme.spacing.s5}px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-right: 0;
  }
  ${props => props.makeFlex && 'display: flex;justify-content: space-between; width: 100%; align-items: baseline;'}
`;
exports.List = styled_components_1.default.div `
  flex-direction: column;
  position: relative;
  margin: 0;
  transition: ${props => props.theme.animations.primary};
  overflow: hidden;
`;
exports.ListItem = (0, styled_components_1.default)(Typography_1.default) `
  &:not(:last-child) {
    margin-bottom: ${props => props.theme.spacing.s2}px;
  }

  &:before {
    display: inline-block;
    content: '';
    border-radius: 50%;
    width: ${props => props.theme.constants.blockHeight.m0}px;
    height: ${props => props.theme.constants.blockHeight.m0}px;
    background-color: black;
    margin-right: ${props => props.theme.spacing.s4}px;
  }
`;
exports.Description = (0, styled_components_1.default)(Typography_1.default) `
  ${props => props.greyColor && `color: ${props.theme.palette.DARK_GRAY_80};`}

  > p {
    margin: 0;
  }
`;
exports.ImageContainer = styled_components_1.default.div `
  display: inline-block;
  position: relative;
  height: ${props => props.theme.constants.blockWidth.s32}px;
  ${props => props.imageUrl && `cursor: pointer;`}
  ${props => props.mobileView &&
    `
    height: ${props.theme.constants.blockHeight.m8}px;
    flex-shrink: 0;
    margin: ${props.theme.spacing.m6}px auto 0 auto;
  `}
`;
exports.Button = (0, styled_components_1.default)(Button_1.default) `
  ${props => props.mobileView && `display: inline-block; margin-left: ${props.theme.spacing.s5}px;`}
  white-space: nowrap;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  > svg {
    display: none;
  }
`;
exports.SearchIconContainer = styled_components_1.default.div `
  width: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  height: ${props => props.theme.constants.mobileMenu.iconWrapper}px;
  background: ${props => props.theme.palette.BW_100};
  right: -${props => props.theme.spacing.s1}px;
  position: absolute;
  bottom: -${props => props.theme.spacing.s3}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
exports.GradientOverlay = styled_components_1.default.div `
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8130602582830007) 100%);
  width: 100%;
  height: ${props => props.theme.spacing.m2}px;
  position: absolute;
  bottom: 0;
  user-select: none;
  ${props => !props.showGradient && 'display: none;'}
`;
exports.ButtonContainer = styled_components_1.default.a `
  display: flex;
  align-items: center;
  height: ${props => props.theme.typography.lineHeight.l2}px;
  margin: 0 ${props => props.theme.spacing.s4}px 0 0;
`;
exports.Image = styled_components_1.default.img `
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
`;
exports.default = {
    Container: exports.Container,
    Title: exports.Title,
    TitleContainer: exports.TitleContainer,
    ButtonContainer: exports.ButtonContainer,
    ArrowIcon: exports.ArrowIcon,
    InfoContainer: exports.InfoContainer,
    List: exports.List,
    ListContainer: exports.ListContainer,
    ImageContainer: exports.ImageContainer,
    Button: exports.Button,
    SearchIconContainer: exports.SearchIconContainer,
    GradientOverlay: exports.GradientOverlay
};
